// extracted by mini-css-extract-plugin
module.exports = {"container":"dispatcher_container__Ct5-2","grid":"dispatcher_grid__2odOO","innergrid":"dispatcher_innergrid__3HWDM","actions":"dispatcher_actions__YFTIH"};